import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiUsers, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import siteData from '../data/siteData';
import contactData from '../data/contactData';
import ScrollReveal from './ScrollReveal';

export default function OurTeam() {
  const { heading, description } = siteData.homepage_sections.our_team;
  const { heading: contactHeading, phone, email } = siteData.homepage_sections.contact_us;

  const contactDetails = [
    { Icon: FiMapPin, label: contactData.offices[0].label, value: contactData.offices[0].address },
    { Icon: FiMapPin, label: contactData.offices[1].label, value: contactData.offices[1].address },
    { Icon: FiMapPin, label: contactData.offices[2].label, value: contactData.offices[2].address },
    { Icon: FiPhone, label: 'Phone Number',   value: phone,  href: `tel:${phone.replace(/\s|-/g,'')}` },
    { Icon: FiMail,  label: 'Email Address',  value: email,  href: `mailto:${email}` },
  ];

  return (
    <section className="home-team-section">
      <div className="container">
        <div className="home-contact-inner">
          {/* Left Side: Our Team text */}
          <ScrollReveal className="home-team-header-text">
            <span className="section-badge">
              <FiUsers size={12} /> Meet the Experts
            </span>
            <h2 className="section-title">{heading}</h2>
            <div className="gold-divider" />
            <p className="section-subtitle">{description}</p>
            <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'flex-end' }}>
              <Link to="/team" className="btn-primary">
                More... <FiArrowRight />
              </Link>
            </div>
          </ScrollReveal>

          {/* Right Side: Contact Us details */}
          <ScrollReveal delay={150} className="home-contact-text-side" style={{ display: 'block' }}>
            <span className="section-badge" style={{ alignSelf: 'flex-start' }}>
              <FiMail size={12} /> Reach Out
            </span>
            <h2 className="section-title">{contactHeading}</h2>
            <div className="gold-divider" />
            
            <div style={{ marginTop: '0px' }}>
              {contactDetails.map(({ Icon, label, value, href }) => (
              <div key={label} className="home-contact-detail-row">
                <div className="home-contact-icon-wrap">
                  <Icon size={18} />
                </div>
                <div>
                  <span className="home-contact-detail-label">{label}</span>
                  {href
                    ? <a href={href} className="home-contact-detail-value">{value}</a>
                    : <span className="home-contact-detail-value">{value}</span>
                  }
                </div>
              </div>
            ))}
            </div>
            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
              <Link to="/contact" className="btn-primary">
                More... <FiArrowRight />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
